module.exports = __webpack_public_path__ + "static/media/screen4.fc5507c6.jpeg";